type LoginResponse = {
    access: string;
    refresh: string;
    user: User;
};

type TokenResponse = {
    access: string;
};

type TokenErrorResponse = {
    detail: string;
    code: string;
};

type Token = {
    token_type: 'access' | 'refresh';
    exp: number;
    iat: number;
    jti: string;
    sub: string;
};

type User = {
    id: string;
    password: string;
    last_login: string | null;
    created_at: string;
    modified_at: string;
    name: string;
    username: string;
    email: string;
    is_active: boolean;
    is_staff: boolean;
    is_superuser: boolean;
    date_joined: string;
    roles: string[];
};
type PermissionResponse = {
    permissions: PERMISSION[];
};

enum PERMISSION {
    ACCESS_CHARGES = 'access_charges',
    MANAGE_CHARGES = 'manage_charges',

    ACCESS_CUSTOMERS = 'access_customers',
    MANAGE_CUSTOMERS = 'manage_customers',

    ACCESS_BILLING_ENTITIES = 'access_billing_entities',
    MANAGE_BILLING_ENTITIES = 'manage_billing_entities',

    ACCESS_DISCOUNTS = 'access_discounts',
    MANAGE_DISCOUNTS = 'manage_discounts',

    ACCESS_VOUCHERS = 'access_vouchers',
    MANAGE_VOUCHERS = 'manage_vouchers',

    ACCESS_FINANCIAL_DOCUMENTS = 'access_financial_documents',
    MANAGE_FINANCIAL_DOCUMENTS = 'manage_financial_documents',
    ISSUE_FINANCIAL_DOCUMENTS = 'issue_financial_documents',

    ACCESS_UNITS = 'access_units',
    MANAGE_UNITS = 'manage_units',

    ACCESS_ACCOUNTING_RANGES = 'access_accounting_ranges',
    MANAGE_ACCOUNTING_RANGES = 'manage_accounting_ranges',

    ACCESS_ACCOUNTING_HEADINGS = 'access_accounting_headings',
    MANAGE_ACCOUNTING_HEADINGS = 'manage_accounting_headings',

    ACCESS_PAYMENTS = 'access_payments',
    MANAGE_PAYMENTS = 'manage_payments',

    ACCESS_SERVICE_PLANS = 'access_service_plans',
    MANAGE_SERVICE_PLANS = 'manage_service_plans',

    ACCESS_SUBSCRIPTIONS = 'access_subscriptions',
    MANAGE_SUBSCRIPTIONS = 'manage_subscriptions',

    ACCESS_TAX_REASONS = 'access_tax_reasons',
    MANAGE_TAX_REASONS = 'manage_tax_reasons',

    ACCESS_MONEY_ACCOUNTS = 'access_money_accounts',
    MANAGE_MONEY_ACCOUNTS = 'manage_money_accounts',

    ACCESS_USERS = 'access_users',
    MANAGE_USERS = 'manage_users',

    MANAGE_ROLES = 'manage_roles',
    ACCESS_ROLES = 'access_roles',
}

export { PERMISSION };

export type { LoginResponse, TokenResponse, TokenErrorResponse, Token, User, PermissionResponse };
